module.exports = __webpack_public_path__ + "static/media/1.6c27213b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/vitebsk/1.jpg
// module id = 248
// module chunks = 0